import { createRoute } from '@tanstack/react-router';
import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';
import { LotSizingsPage } from '@/pages/lot-sizings/lot-sizings-page';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'lot-sizings',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <LotSizingsPage />
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: {
    titleKey: 'LotSizings',
  },
});
